import Script from 'next/script';

import { useConsentManager } from './consent-manager';

/**
 * Load the DemandBase script after airgap.js is initialized
 */
export const DemandBaseScript: React.FC = () => {
  const { airgap } = useConsentManager();

  return (
    <>
      {airgap && (
        <Script
          id="demandbase-init"
          strategy="lazyOnload"
          dangerouslySetInnerHTML={{
            __html: `
              (function(d, b, a, s, e) {
                var t = b.createElement(a);
                var fs = b.getElementsByTagName(a)[0];
                t.async = 1;
                t.id = e;
                t.src = s;
                fs.parentNode.insertBefore(t, fs);
              })(window, document, 'script', 'https://tag.demandbase.com/6ca09ff78067db02.min.js', 'demandbase_js_lib');
            `,
          }}
        />
      )}
    </>
  );
};
